/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import primaryComponents from "../../../../../../components/primaryComponents";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { PlusIcon } from "../../../../../../assets/svgIcons";
import { useAllBills } from "./useAllBills";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../../routes/pathContants";
import { BillsTable } from "../../../../../../components/secondaryComponents/Bills";

const paymentOptions = [
  {
    name: "Paid",
    id: "PAID",
  },
  {
    name: "Partially Paid",
    id: "PARTIALLY_PAID",
  },
  {
    name: "Unpaid",
    id: "UNPAID",
  },
];
export const AllBills = () => {
  const {
    search,
    storeList,
    billsStatus,
    bills,
    isLoadingBills,
    isLoadingExtra,
    metaDetails,
    suppliers,
    filterByDate,
    filterByStoreId,
    filterBySearch,
    gotoPage,
    filterByKey,
  } = useAllBills();
  const navigate = useNavigate();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Bills"
      description="View of all bills"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Bills</h4>
            <p>
              Generate bills by matching purchase orders against goods received,
              then create the final bill for payment.
            </p>
          </div>

          <div className={globalStyles.rowNavigations}>
            {billsStatus?.map((item, index) => (
              <a
                key={index}
                className={`${globalStyles.rowNavigations__item} ${
                  search.get("status") === item?.value
                    ? globalStyles.active
                    : ""
                }`}
                onClick={() => filterByKey("status", item?.value)}
              >
                {item?.label}{" "}
                {item?.value === "IN_REVIEW" ? (
                  <span className={`ml-1 ${globalStyles.noOfPends}`}>
                    {metaDetails?.total_in_review || 0}
                  </span>
                ) : null}
              </a>
            ))}
          </div>

          <div className={globalStyles.pageHeaders}>
            <p style={{ textTransform: "lowercase" }}>
              {metaDetails?.total} {search.get("status")?.replace("_", " ")}
            </p>

            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey={"can_create_or_update_bill"}
            >
              <primaryComponents.Button
                classNames={"btn btn--primary ml-auto"}
                onClick={() => navigate(pathConstants.INVENTORY_BILLS_CREATE)}
              >
                <PlusIcon className="mr-1" /> Create Bill
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>

          {/* table section */}
          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                classNames={`${globalStyles.searchField}`}
                placeholder="Search by bill number, PO number or supplier"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") || ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />

              <secondaryComponents.LoaderHelper
                isLoading={isLoadingExtra}
                classNames="mt-2"
              >
                <div className="ml-auto" style={{ width: "170px" }}>
                  <primaryComponents.SelectField
                    options={[
                      {
                        name: "All Payment",
                        id: null,
                      },
                      ...paymentOptions,
                    ]}
                    idKey="id"
                    nameKey="name"
                    onChange={(value) => {
                      filterByKey("payment_status", value);
                    }}
                    value={
                      paymentOptions?.find(
                        (status) =>
                          `${status?.id}` === search.get("payment_status"),
                      )?.name || "Filter payment"
                    }
                    floatError={false}
                    isSearchable={false}
                  />
                </div>
                <div style={{ width: "140px" }}>
                  <primaryComponents.SelectField
                    options={[
                      {
                        name: "All stores",
                        id: null,
                      },
                      ...storeList,
                    ]}
                    idKey="id"
                    nameKey="name"
                    onChange={(value) => {
                      filterByStoreId(value);
                    }}
                    value={
                      storeList?.find(
                        (store) => `${store?.id}` === search.get("store_id"),
                      )?.name || "Filter store"
                    }
                    floatError={false}
                    isSearchable={false}
                  />
                </div>
                <div style={{ width: "160px" }}>
                  <primaryComponents.SelectField
                    options={[
                      {
                        name: "All suppliers",
                        id: null,
                      },
                      ...suppliers,
                    ]}
                    idKey="id"
                    nameKey="name"
                    onChange={(value) => {
                      filterByKey("supplier_id", value);
                    }}
                    value={
                      storeList?.find(
                        (store) => `${store?.id}` === search.get("supplier_id"),
                      )?.name || "Filter Supplier"
                    }
                    floatError={false}
                    isSearchable={false}
                  />
                </div>

                <primaryComponents.DateRangeInput
                  startDate={search.get("start_date")}
                  endDate={search.get("end_date")}
                  onChange={filterByDate}
                  showPlaceholder={true}
                />
              </secondaryComponents.LoaderHelper>
            </div>

            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingBills}
              classNames="mt-5"
            >
              <BillsTable
                bills={bills}
                metaDetails={metaDetails}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
